/**
 * @param {string} locale
 * @param {Date} date
 * @return {string}
 */
export function toIntlRelativeTimeFormat(locale, date) {
  // TODO: Probably move it to "packages/date" at some point
  if (date instanceof Date && !Number.isNaN(date.getTime())) {
    const rtf = new Intl.RelativeTimeFormat(
      // NOTE: Use "-GB" to force dd/mm/yyyy date styling
      locale === 'en' ? 'en-GB' : locale,
      { numeric: 'auto' },
    );

    const today = new Date();
    const diffInMs = date - today;
    const diffInWeeks = Math.round(diffInMs / (1000 * 60 * 60 * 24 * 7));

    return rtf.format(diffInWeeks, 'week');
  }

  return '';
}
